import { render, staticRenderFns } from "./IdentificationType.vue?vue&type=template&id=65d9651e&scoped=true"
import script from "./IdentificationType.vue?vue&type=script&lang=js"
export * from "./IdentificationType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d9651e",
  null
  
)

export default component.exports